export default {
    STATIC: 'STATIC',
    REQUESTING: 'REQUESTING',
};
